import type { TechniqueEntry } from '../schema';

// review: candidate draft grounded in the NIAAA CBI manual — no shipped delivery prose in the
// repo; needs genuine clinical origination review, not just sign-off.
export const functionalAnalysis: TechniqueEntry = {
  key: 'functional_analysis',
  version: '0.1-candidate',
  name: 'Functional analysis',
  pillar: 'CBT',
  serves:
    'Walking one specific, real episode step by step (before, during, after) to expose the trigger → thought/feeling → behaviour → payoff chain, and the function the use actually served that time.',
  method: [
    'Anchor on one concrete recent occasion, not patterns in general (that is descent work, the explicit boundary in the shipped Movement A prose).',
    'Never use the clinical jargon (functional analysis, antecedents) with the member, and keep the questions in past tense: the manual is explicit that present- or future-tense framing can alarm or alienate an abstinent member.',
    "Before: where they were, who was around, what the day had been like, the first signal; the manual's probes cover the senses (what they saw, heard, smelled, felt).",
    'During: what went through their mind, what they felt, what they did, how it unfolded against the plan.',
    "After: what it gave them in the moment (taken at face value, this is the member's own perceived effect and explicitly not the moment to correct it) and what it cost afterwards, in their words.",
    "Close by naming the trigger→effect chain back once and letting them correct it. Where the moment allows, finish on the manual's positive functional analysis: turn to the antecedents of not using: the times they are least likely to reach for it, and where the fun without it already lives. The corrected chain is the artifact the next moves build on.",
  ],
  never: [
    'Never on generalities: nothing concrete described yet means this move is ineligible.',
    'Not a confession or an audit: zero judgment on quantities.',
    "Never moralise or correct the payoff: the manual is explicit this is not the time to correct the client's expectancies; the function is information.",
    {
      constraint: 'Never in clinical jargon, never in present-tense framing of their use.',
      phrase: 'when you drink',
    },
  ],
  requiresFirst: [
    {
      kind: 'conversation',
      clause: 'At least one real occasion named.',
    },
  ],
  doneWhen:
    'The member states the chain of one episode in their own words (trigger, response, payoff, cost) and something in it surprises them or gets corrected toward precision.',
  firstMove: null,
  exemplars: [],
  appliesTo: ['base', 'journey'],
  programs: null,
  signature: null,
  source:
    'NIAAA CBI manual §3.2 (pp. 64–67 — New Roads worksheet: Triggers/Effects columns, past-tense rule, positive-FA close) + §5.3b (craving-situation probes); catalog #22 (CRA); base doc table row; boundary named in practice_objective.md. No shipped prose in our repo.',
};
